
export default {
  data() {
    return {

      form : {
                id : '',
                judul : '',
                isi : '',
                status : '',
                keterangan : '',
                file : null,
                userId : '',
                createBy : '',
                createAt : '',
                editedAt : '',
                file_old : null
            },
     
      list_data : [],
      file_path: this.$store.state.url.URL_APP + "uploads/",

      page_first: 1,
      page_last: 0,
      cari_value: "",
      cek_load_data : true,


      mdl_add: false,
      mdl2: false,
      mdl3: false,
      mdl_open: false,
      mdl_edit: false,
      mdl_hapus : false,
      btn_add: false,
    }
  },
  methods: {


    getView : function(){
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_VerifikasiSida + "view", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              data_ke: this.page_first,
              cari_value: this.cari_value
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jml_data;
              this.$store.commit("hideLoading");
              console.log(res_data);
      });
    },


    addData : function() {
      var formData = new FormData();
      formData.append('data', JSON.stringify(this.form))
      formData.append('file', this.form.file)

      // console.log(formData);

      fetch(this.$store.state.url.URL_Sida + "addData", {
          method: "POST",
          headers: {
            // "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: formData
      }).then(res_data => {
          this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
          console.log(res_data);
          this.getView();
      });
    },


    editData : function(){
      var formData = new FormData();
      formData.append('data', JSON.stringify(this.form))
      formData.append('file', this.form.file)
      fetch(this.$store.state.url.URL_Sida + "editData", {
          method: "POST",
          headers: {
            // "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: formData
      }).then(res_data => {
          this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
          this.getView();
      });
    },

    removeData : function(a, b){
      // console.log(a);
      // console.log(b);
      fetch(this.$store.state.url.URL_VerifikasiSida + "removeData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({id : a, file : b})
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
          this.getView();
      });

    },
    tolak_data : function(){
        var formData = new FormData();
        formData.append("id", this.form.id);
        formData.append("keterangan", this.form.keterangan); 

        fetch(this.$store.state.url.URL_VerifikasiSida + "kembalikan_data", {
            method: "POST",
            headers: {
            authorization: "kikensbatara " + localStorage.token
            },
            body: formData
        }).then(res_data => {
            this.Notify('Berhasil Mengembalikan Data', 'orange', 'check_circle_outline');
            this.getView();
        });
    },

    terima_data : function(){
        var formData = new FormData();
        formData.append("id", this.form.id);
        formData.append("keterangan", this.form.keterangan);
        console.log(formData);


        fetch(this.$store.state.url.URL_VerifikasiSida + "terima_data", {
            method: "POST",
            headers: {
            authorization: "kikensbatara " + localStorage.token
            },
            body: formData
        }).then(res_data => {
            this.Notify('Berhasil Verifikasi Data', 'green', 'check_circle_outline');
            this.getView();
        });
    },
    
    selectData : function(data){
        this.form.id = data.id
        this.form.judul = data.judul
        this.form.isi = data.isi
        this.form.status = data.status
        this.form.keterangan = data.keterangan
        this.form.file = this.form.file
        this.form.createAt = data.createAt
        this.form.file_old =  data.file
    },

    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },
        btn_prev : function(){
            this.cek_load_data = true;
            if(this.page_first>1){
                this.page_first--
            }else{
                this.page_first = 1;
            }
            this.getView();
        },

        btn_next : function(){
            if(this.page_first >= this.page_last){
                this.page_first == this.page_last
            }else{
                this.page_first++;
            }
            this.getView();
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
        },


    // ====================================== PAGINATE ====================================







  },

  mounted () {
    this.getView();
  },
}
